/**
 * @file mixin Mixin function based on Prototype.
 * @author yuzong(yuzong@tencent.com)
 */

/**
 * Mixin function based on Prototype.
 *
 * @param Base Target function.
 * @param args Source functions.
 */
export function mixin(Base) {
  var obj = Base.prototype;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  args.forEach(function (target) {
    var prototype = target.prototype;
    var descriptor = Object.getOwnPropertyDescriptors(prototype);
    Object.keys(descriptor).forEach(function (key) {
      Object.defineProperty(obj, key, descriptor[key]);
    });
  });
}